/**
 * Datum exportu Takeout (F2.8): z razítka v názvu dílu `takeout-YYYYMMDDTHHMMSSZ-NNN.zip`
 * (UTC den razítka), jinak den nahrání.
 */

import { isGoogleReviewTime } from "../googleReviews";

const STAMP = /takeout-(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z/i;

/**
 * `YYYY-MM-DD` z razítka kdekoli v názvu (prohlížeč druhé stažení přejmenuje na
 * `takeout-…-001 (1).zip`), nebo `null`. Neexistující datum či čas (měsíc 13, 31. 2.)
 * razítkem není.
 */
export function exportDateFromFileName(name: string): string | null {
  const m = STAMP.exec(name);
  if (!m) return null;
  const [, y, mo, d, h, mi, s] = m;
  return isGoogleReviewTime(`${y}-${mo}-${d}T${h}:${mi}:${s}Z`) ? `${y}-${mo}-${d}` : null;
}

/**
 * Místní den prohlížeče jako `YYYY-MM-DD` (majitel nahrává z Česka; UTC by po půlnoci
 * SELČ dalo včerejšek). Z `getFullYear`/`getMonth`/`getDate`, ne z `toLocaleDateString`.
 */
export function localDayIso(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
